interface ImageSize {
  width: number;
  height: number;
}

export const logoSize: ImageSize = {
  width: 160,
  height: 80,
};

export const iconSize: ImageSize = {
  width: 128,
  height: 128,
};

export const timerDuration = 5;
